var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrincipalBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 918,
    viewBox: "0 0 601 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.813 790.05C314.933 790.05 318.272 786.711 318.272 782.594C318.272 778.475 314.933 775.138 310.813 775.138V790.05ZM233.219 621.731C235.236 618.141 233.959 613.595 230.367 611.579C226.776 609.563 222.228 610.84 220.211 614.43L233.219 621.731ZM378.262 573.375C382.383 573.375 385.722 570.036 385.722 565.919C385.722 561.8 382.383 558.463 378.262 558.463V573.375ZM248.845 580.098C245.596 582.629 245.014 587.314 247.546 590.562C250.078 593.812 254.764 594.393 258.014 591.863L248.845 580.098ZM310.813 775.138C261.07 775.138 219.615 730.771 219.615 674.584H204.696C204.696 737.701 251.581 790.05 310.813 790.05V775.138ZM219.615 674.584C219.615 655.154 224.608 637.059 233.219 621.731L220.211 614.43C210.351 631.979 204.696 652.587 204.696 674.584H219.615ZM378.262 558.463H311.051V573.375H378.262V558.463ZM311.051 558.463C287.779 558.463 266.286 566.52 248.845 580.098L258.014 591.863C273.004 580.191 291.311 573.375 311.051 573.375V558.463Z",
    fill: "#004699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8773 369.57C21.5105 369.57 5 385.827 5 405.882C5 425.939 21.5105 442.196 41.8773 442.196C62.244 442.196 78.7547 425.939 78.7547 405.882V257.573",
    stroke: "#3391FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.229 49.1722C362.229 70.4478 379.457 87.6954 400.709 87.6954C421.961 87.6954 439.19 70.4478 439.19 49.1722V5.64099",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.904 282.575C393.073 282.575 404.559 271.094 404.559 256.932C404.559 242.771 393.073 231.29 378.904 231.29C364.736 231.29 353.251 242.771 353.251 256.932C353.251 271.094 364.736 282.575 378.904 282.575Z",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.801 210.136C142.116 210.136 160.206 192.054 160.206 169.75C160.206 147.444 142.116 129.364 119.801 129.364C97.4863 129.364 79.3965 147.444 79.3965 169.75C79.3965 192.054 97.4863 210.136 119.801 210.136Z",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.476 270.394C192.109 270.394 175.598 286.898 175.598 307.255C175.598 327.612 192.109 344.115 212.476 344.115C232.842 344.115 249.353 327.612 249.353 307.255V270.394",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.571 872.982C588.571 852.446 605.094 835.8 625.475 835.8C645.856 835.8 662.378 852.446 662.378 872.982C662.378 893.516 645.856 910.162 625.475 910.162H566.818",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.442 428.092V576.584C483.442 620.968 519.765 656.948 564.573 656.948C609.38 656.948 645.704 620.968 645.704 576.584V541.5",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.541 679.384H453.815C504.536 679.384 545.654 720.713 545.654 771.694C545.654 822.674 504.536 864.006 453.815 864.006H413.722",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.701 135.133H348.323C293.663 135.133 249.353 179.619 249.353 234.495",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3332 213.982C30.3332 219.953 30.3332 295.105 30.3332 331.935",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.13 749.899C601.13 751.911 601.13 777.231 601.13 789.644",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.121 257.573C169.887 257.573 210.231 217.823 210.231 168.788C210.231 119.753 169.887 80.0029 120.121 80.0029C70.3559 80.0029 30.0125 119.753 30.0125 168.788",
    stroke: "#8994AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.489 257.573C443.489 221.107 414.387 191.545 378.488 191.545C342.588 191.545 313.486 221.107 313.486 257.573C313.486 294.039 342.588 323.602 378.488 323.602H548.86",
    stroke: "#8994AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.711 563.354C151.637 563.354 134.551 546.306 134.551 525.276V416.81C134.551 395.781 151.637 378.732 172.711 378.732C193.787 378.732 210.871 395.781 210.871 416.81V525.276C210.871 546.306 193.787 563.354 172.711 563.354Z",
    stroke: "#8994AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.982 208.809V213.802C587.982 242.224 564.867 265.266 536.354 265.266C507.841 265.266 484.725 242.224 484.725 213.802V57.1051C484.725 28.6822 507.841 5.64099 536.354 5.64099C564.867 5.64099 587.982 28.6822 587.982 57.1051V58.6413",
    stroke: "#8994AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8097 615.279H44.7243C22.7853 615.279 5 633.073 5 655.024C5 676.974 22.7851 694.769 44.7243 694.769H136.515C158.455 694.769 176.239 676.974 176.239 655.024C176.239 633.073 158.455 615.279 136.515 615.279H133.429",
    stroke: "#8994AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.418 631.412C437.538 631.412 440.877 628.075 440.877 623.956C440.877 619.839 437.538 616.5 433.418 616.5V631.412ZM365.835 735.852C369.954 735.852 373.294 732.514 373.294 728.396C373.294 724.278 369.954 720.94 365.835 720.94V735.852ZM237.064 917.618C241.184 917.618 244.523 914.279 244.523 910.162C244.523 906.044 241.184 902.706 237.064 902.706V917.618ZM373.636 782.625C373.636 778.506 370.296 775.169 366.177 775.169C362.056 775.169 358.717 778.506 358.717 782.625H373.636ZM259.224 381.936C259.224 377.819 255.884 374.48 251.765 374.48C247.644 374.48 244.305 377.819 244.305 381.936H259.224ZM425.958 568.723C425.958 572.842 429.299 576.179 433.418 576.179C437.538 576.179 440.877 572.842 440.877 568.723H425.958ZM433.418 616.5H318.338V631.412H433.418V616.5ZM318.338 616.5C285.247 616.5 258.356 643.181 258.356 676.177H273.275C273.275 651.491 293.413 631.412 318.338 631.412V616.5ZM258.356 676.177C258.356 709.171 285.247 735.852 318.338 735.852V720.94C293.413 720.94 273.275 700.861 273.275 676.177H258.356ZM318.338 735.852H365.835V720.94H318.338V735.852ZM237.064 902.706H230.204V917.618H237.064V902.706ZM230.204 902.706C214.092 902.706 201.015 889.629 201.015 873.491H186.096C186.096 897.849 205.836 917.618 230.204 917.618V902.706ZM201.015 873.491C201.015 857.345 214.093 844.268 230.204 844.268V829.356C205.836 829.356 186.096 849.127 186.096 873.491H201.015ZM230.204 844.268H312.027V829.356H230.204V844.268ZM312.027 844.268C346.06 844.268 373.636 816.663 373.636 782.625H358.717C358.717 808.444 337.805 829.356 312.027 829.356V844.268ZM244.305 381.936V423.147H259.224V381.936H244.305ZM244.305 423.147C244.305 477.454 288.301 521.491 342.591 521.491V506.579C296.556 506.579 259.224 469.235 259.224 423.147H244.305ZM342.591 521.491H378.767V506.579H342.591V521.491ZM378.767 521.491C404.823 521.491 425.958 542.63 425.958 568.723H440.877C440.877 534.411 413.077 506.579 378.767 506.579V521.491Z",
    fill: "#3391FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.451 808.235C469.996 808.235 486.65 791.732 486.65 771.374C486.65 751.017 469.996 734.514 449.451 734.514C428.908 734.514 412.254 751.017 412.254 771.374C412.254 791.732 428.908 808.235 449.451 808.235Z",
    stroke: "#3391FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.698 54.6813C223.698 81.7653 245.521 103.721 272.441 103.721C299.361 103.721 321.183 81.7653 321.183 54.6813C321.183 27.5971 299.361 5.64099 272.441 5.64099H223.698",
    stroke: "#3391FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.825 514.955V457.687C532.825 441.343 546.178 428.092 562.648 428.092C579.119 428.092 592.471 441.343 592.471 457.687V572.222C592.471 588.567 579.119 601.816 562.648 601.816C546.178 601.816 532.825 588.567 532.825 572.222V558.386",
    stroke: "#3391FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.332 94.6128C598.663 94.6128 580.285 112.724 580.285 135.066C580.285 157.407 598.663 175.519 621.332 175.519C644 175.519 662.377 157.407 662.377 135.066V5",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.621 454.376H346.075C324.889 454.376 307.714 437.154 307.714 415.912C307.714 394.67 324.889 377.449 346.075 377.449H409.167C430.353 377.449 447.528 394.67 447.528 415.912V419.33C447.528 438.684 431.878 454.376 412.574 454.376",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.878 377.45H543.968C586.341 377.45 620.691 343.009 620.691 300.524",
    stroke: "#004699",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipalBanner);
export default __webpack_public_path__ + "static/media/principal-banner.745686a65589abdd30aba27ee8fbacf2.svg";
export { ForwardRef as ReactComponent };